import { render, staticRenderFns } from "./PhdProposal.vue?vue&type=template&id=4deb75ec&scoped=true&"
import script from "./PhdProposal.vue?vue&type=script&lang=js&"
export * from "./PhdProposal.vue?vue&type=script&lang=js&"
import style0 from "./PhdProposal.vue?vue&type=style&index=0&id=4deb75ec&prod&lang=css&"
import style1 from "./PhdProposal.vue?vue&type=style&index=1&id=4deb75ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb75ec",
  null
  
)

export default component.exports